(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('Club', Club);

    var toJson = angular.toJson;

    Club.$inject = ['$resource', 'urls', 'httpMethods'];
    function Club($resource, urls, httpMethods) {
        return $resource('', { id: '@id' }, {
            getClubInfo: { url: urls.getClubInfo, method: httpMethods.get },
            saveClubInfo: { url: urls.saveClubInfo, method: httpMethods.post, transformRequest: tranformClubInfoRequest, headers: { 'Content-Type': undefined } },
            getClubStats: { url: urls.getClubStats, method: httpMethods.get },
            getClubTransactionLog: { url: urls.getClubTransactionLog, method: httpMethods.get },
            getClubTeeTimeComparisonReport: { url: urls.getClubTeeTimeComparisonReport, method: httpMethods.get },
            getClubMemberRoster: { url: urls.getClubMemberRoster, method: httpMethods.get },
            getActiveRoster: { url: urls.getActiveRoster, method: httpMethods.get },
            getClubHandicapReview: { url: urls.getClubHandicapReview, method: httpMethods.get },

            getAdminClubs: { url: urls.getAdminClubs, method: httpMethods.get },
            getAdminClub: { url: urls.getAdminClub, method: httpMethods.get },
            adjustMembershipCredits: { url: urls.adjustMembershipCredits, method: httpMethods.post },
            getClubLevels: { url: urls.getClubLevels, method: httpMethods.get, isArray: true },

            getSubgroups: { url: urls.getSubgroups, method: httpMethods.get, isArray: true },
            saveSubgroup: { url: urls.saveSubgroup, method: httpMethods.post },
            deleteSubgroup: { url: urls.deleteSubgroup, method: httpMethods.post },

            getSubgroupMembers: { url: urls.getSubgroupMembers, method: httpMethods.get, isArray: true },
            addSubgroupMember: { url: urls.addSubgroupMember, method: httpMethods.post },
            removeSubgroupMember: { url: urls.removeSubgroupMember, method: httpMethods.post },
            searchSubgroupCandidates: { url: urls.searchSubgroupCandidates, method: httpMethods.get },

            getReports: { url: urls.getReports, method: httpMethods.get, isArray: true },
            search: { url: urls.searchClubs, method: httpMethods.get },

            getTransferList: { url: urls.getTransferList, method: httpMethods.get },
            acceptTransfer: { url: urls.acceptTransfer, method: httpMethods.post },
            rejectTransfer: { url: urls.rejectTransfer, method: httpMethods.post },
            getManagementGroups: { url: urls.getManagementGroups, method: httpMethods.get, isArray: true },

            getClubContacts: { url: urls.getClubContacts, method: httpMethods.get, isArray: true },
            saveClubContact: { url: urls.saveClubContact, method: httpMethods.post },
            deleteClubContact: { url: urls.deleteClubContact, method: httpMethods.post },
            verifyClubContact: { url: urls.verifyClubContact, method: httpMethods.post },
            verifyAllClubContacts: { url: urls.verifyAllClubContacts, method: httpMethods.post },

            getClubFacility: { url: urls.getClubFacility, method: httpMethods.get },            
            saveClubFacility: { url: urls.saveClubFacility, method: httpMethods.post },

            getUserClubRoster: { url: urls.getUserClubRoster, method: httpMethods.get }
        });

        function tranformClubInfoRequest(data) {
            var formData = new FormData(),
                logoBlob = data.logoBlob !== null ? data.logoBlob : new Blob([]);

            formData.append('$model', new Blob([toJson(data)], { type: 'application/json' }));
            if (logoBlob)
                formData.append('logoBlob', logoBlob, logoBlob.name);
            return formData;
        }

        //function tranformClubFacilityRequest(data) {
        //    var formData = new FormData();
        //   //     logoBlob = data.logoBlob !== null ? data.logoBlob : new Blob([]);

        //  //  formData.append('$model', new Blob([toJson(data)], { type: 'application/json' }));
        //   // if (logoBlob)
        //   //     formData.append('logoBlob', logoBlob, logoBlob.name);
        //    return formData;
        //}

    }
})();